/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_Feature_3Inputs */

const et_plan_visibility_feature_3 = /** @type {(inputs: Plan_Visibility_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinu ettevõte jätab usaldusväärsema mulje`)
};

const en_plan_visibility_feature_3 = /** @type {(inputs: Plan_Visibility_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your business looks more trustworthy`)
};

/**
* | output |
* | --- |
* | "Your business looks more trustworthy" |
*
* @param {Plan_Visibility_Feature_3Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_feature_3 = /** @type {((inputs?: Plan_Visibility_Feature_3Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_Feature_3Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_feature_3(inputs)
	return en_plan_visibility_feature_3(inputs)
});